if (!customElements.get('sjelf-audio-browser')) {
  customElements.define('sjelf-audio-browser', class extends HTMLElement {
    connectedCallback() {
      if (this.audioInitialized) return;
      this.audioInitialized = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-audio-filter]');
        if (!button || !this.contains(button)) return;
        this.filterAudio(button.dataset.audioFilter);
      });
      this.filterAudio('all');
    }
    filterAudio(category) {
      const cards = [...this.querySelectorAll('[data-audio-card]')];
      this.querySelectorAll('[data-audio-filter]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.audioFilter === category));
      });
      let visible = 0;
      cards.forEach(card => {
        card.hidden = category !== 'all' && card.dataset.category !== category;
        if (!card.hidden) visible++;
      });
      const result = this.querySelector('[data-audio-result]');
      if (result) {
        const sample = cards.some(card => card.classList.contains('sjelf-audio-card--preview'));
        const suffix = sample ? result.dataset.sample : visible === 1 ? result.dataset.singular : result.dataset.plural;
        result.textContent = `${visible} ${suffix}`;
      }
    }
  });
}
